export default "__VITE_ASSET__99bb571a__"